document.addEventListener('DOMContentLoaded', function() {

  var summaryEl = document.getElementById('wegs-summary-content');
  if (summaryEl) summaryEl.style.display = 'none';

  var popupHtml = '<div id="wegs-popup-overlay" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;align-items:center;justify-content:center;">'
    + '<div style="background:#fff;border-radius:8px;padding:32px;max-width:440px;width:90%;position:relative;box-shadow:0 8px 32px rgba(0,0,0,0.2);">'
    + '<button id="wegs-popup-close" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:22px;cursor:pointer;color:#888;">x</button>'
    + '<h2 style="color:#D32F2F;font-size:20px;font-weight:700;margin:0 0 6px;">Almost there!</h2>'
    + '<p style="color:#666;font-size:13px;margin:0 0 20px;">Please fill in your details to download the estimate.</p>'
    + '<div style="margin-bottom:14px;"><label style="display:block;font-size:13px;font-weight:600;color:#333;margin-bottom:4px;">Full Name <span style="color:#D32F2F;">*</span></label>'
    + '<input id="wegs-f-name" type="text" placeholder="Your name" style="width:100%;padding:10px 12px;border:1.5px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;"></div>'
    + '<div style="margin-bottom:14px;"><label style="display:block;font-size:13px;font-weight:600;color:#333;margin-bottom:4px;">Phone Number <span style="color:#D32F2F;">*</span></label>'
    + '<input id="wegs-f-phone" type="tel" placeholder="10-digit mobile number" style="width:100%;padding:10px 12px;border:1.5px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;"></div>'
    + '<div style="margin-bottom:14px;"><label style="display:block;font-size:13px;font-weight:600;color:#333;margin-bottom:4px;">City <span style="color:#888;font-weight:400;">(optional)</span></label>'
    + '<input id="wegs-f-city" type="text" placeholder="Your city" style="width:100%;padding:10px 12px;border:1.5px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;"></div>'
    + '<div style="margin-bottom:14px;"><label style="display:block;font-size:13px;font-weight:600;color:#333;margin-bottom:4px;">Email <span style="color:#888;font-weight:400;">(optional)</span></label>'
    + '<input id="wegs-f-email" type="email" placeholder="your@email.com" style="width:100%;padding:10px 12px;border:1.5px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;"></div>'
    + '<div style="margin-bottom:20px;"><label style="display:block;font-size:13px;font-weight:600;color:#333;margin-bottom:4px;">When do you need this? <span style="color:#D32F2F;">*</span></label>'
    + '<select id="wegs-f-when" style="width:100%;padding:10px 12px;border:1.5px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;background:#fff;">'
    + '<option value="">-- Select --</option>'
    + '<option value="Immediate">Immediate</option>'
    + '<option value="This Week">This Week</option>'
    + '<option value="This Month">This Month</option>'
    + '<option value="Just Enquiring">Just Enquiring</option>'
    + '</select></div>'
    + '<div id="wegs-popup-error" style="color:#D32F2F;font-size:13px;margin-bottom:12px;display:none;"></div>'
    + '<button id="wegs-popup-submit" style="width:100%;background:#D32F2F;color:#fff;border:none;padding:14px;border-radius:4px;font-size:15px;font-weight:700;cursor:pointer;text-transform:uppercase;letter-spacing:0.5px;">Download PDF</button>'
    + '</div></div>';

  document.body.insertAdjacentHTML('beforeend', popupHtml);

  var overlay = document.getElementById('wegs-popup-overlay');

  function openPopup() { overlay.style.display = 'flex'; }
  function closePopup() {
    overlay.style.display = 'none';
    document.getElementById('wegs-popup-error').style.display = 'none';
  }

  document.getElementById('wegs-popup-close').addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closePopup(); });

  var btnPdf = document.getElementById('wegs-btn-pdf');
  if (btnPdf) {
    btnPdf.addEventListener('click', function() {
      var quantities = window.__wegsQuantities || {};
      var hasItems = false;
      Object.keys(quantities).forEach(function(k) {
        if ((parseInt(quantities[k], 10) || 0) > 0) hasItems = true;
      });
      if (!hasItems) { alert('Please add at least one product before downloading.'); return; }
      openPopup();
    });
  }

  document.getElementById('wegs-popup-submit').addEventListener(
  'click',
  async function() {
    var name = document.getElementById('wegs-f-name').value.trim();
    var phone = document.getElementById('wegs-f-phone').value.trim();
    var city = document.getElementById('wegs-f-city').value.trim();
    var email = document.getElementById('wegs-f-email').value.trim();
    var when = document.getElementById('wegs-f-when').value;
    var errEl = document.getElementById('wegs-popup-error');
    var submitBtn = document.getElementById('wegs-popup-submit');

    if (!name || !phone || !email || !when) {
      errEl.textContent =
        'Please fill in Name, Phone, Email and Requirement.';
      errEl.style.display = 'block';
      return;
    }

    if (phone.length < 10) {
      errEl.textContent = 'Please enter a valid phone number.';
      errEl.style.display = 'block';
      return;
    }

    errEl.style.display = 'none';

    submitBtn.disabled = true;
    submitBtn.style.background = '#b71c1c';
    submitBtn.style.opacity = '0.85';
    submitBtn.textContent = '⏳ Generating PDF, please wait...';

    var quantities = window.__wegsQuantities || {};
    var products = window.__wegsProducts || [];
    var items = [];
    var total = 0;

    products.forEach(function(p) {
      p.variants.forEach(function(variant) {
        var rowId =
          String(p.id) + '_' + String(variant.id);

        var q =
          parseInt(quantities[rowId] || 0, 10);

        if (q > 0) {
          var price =
            parseFloat(variant.price || 0);

          var amount = price * q;

          total += amount;

          var variantTitle =
            variant.title &&
            variant.title !== 'Default Title'
              ? ' - ' + variant.title
              : '';

          items.push({
            productName:
              p.title + variantTitle,
            sku:
              variant.sku || '',
            quantity:
              q,
          });
        }
      });
    });

    if (items.length === 0) {
      errEl.textContent =
        'Please add at least one product.';
      errEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Download PDF';
      return;
    }

    var estimateId =
      'WEGS' +
      String(Date.now());

    var payload = {
      estimateId: estimateId,

      estimateDate:
        new Date().toISOString().slice(0, 10),

         source: 'website_estimate',

      status: 'Created',

      requirement: when,

      customer: {
        name: name,
        email: email,
        phone: phone,
        city: city,
        country: 'India',
      },

      items: items,

      totals: {
        subtotal: total,
        discount: 0,
        tax: 0,
        shipping: 0,
        total: total,
        currency: 'INR',
      },

      pdfUrl: '',

      shopify: {
        store:
          window.location.hostname,
      },
    };

        try {
      var generated =
        await generatePDF(
          name,
          phone,
          city,
          email,
          when
        );


      payload.estimateId =
        generated.estimateId;

      payload.totals.total =
        generated.total;

      payload.totals.subtotal =
        generated.total;

      payload.items =
        generated.items;

        payload.pdfHtml =
          generated.html;


      var response =
        await fetch(
          '/apps/wegs-estimate',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',
            },

            body:
              JSON.stringify(payload),
          }
        );

      var result =
        await response.json();

      if (!response.ok ||
          !result.success ||
          !result.estimate ||
          !result.estimate.pdfUrl) {
        throw new Error(
          result.message ||
          'Unable to save the estimate PDF.'
        );
      }

      var pdfUrl =
        result.estimate.pdfUrl;

      window.open(
        pdfUrl,
        '_blank'
      );

    } catch (error) {
      console.error(
        'WEGS estimate error:',
        error
      );

      errEl.textContent =
        error.message ||
        'Unable to create estimate. Please try again.';

      errEl.style.display = 'block';

      submitBtn.disabled = false;
      submitBtn.textContent = 'Download PDF';
    }
  }
);

function loadHtml2Pdf() {
  if (window.html2pdf) {
    return Promise.resolve();
  }

  return new Promise(function(resolve, reject) {
    var script = document.createElement('script');

    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/' +
      'html2pdf.js/0.10.1/html2pdf.bundle.min.js';

    script.onload = function() {
      if (window.html2pdf) {
        resolve();
      } else {
        reject(new Error('html2pdf failed to load.'));
      }
    };

    script.onerror = function() {
      reject(new Error('Unable to load PDF generator.'));
    };

    document.head.appendChild(script);
  });
}

function blobToBase64(blob) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();

    reader.onloadend = function() {
      var result = reader.result || '';
      var commaIndex = result.indexOf(',');

      if (commaIndex === -1) {
        reject(new Error('Unable to convert PDF.'));
        return;
      }

      resolve(result.substring(commaIndex + 1));
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
  async function generatePDF(name, phone, city, email, when) {
    var quantities = window.__wegsQuantities || {};
    var products   = window.__wegsProducts   || [];
    var sel = [];
    var tot = 0;
    var totalSaved = 0;

    products.forEach(function(p) {
      p.variants.forEach(function(variant) {
        var rowId = String(p.id) + '_' + String(variant.id);
        var q = parseInt(quantities[rowId] || 0, 10);
        if (q > 0) {
          var pr    = parseFloat(variant.price || 0);
          var mrp   = parseFloat(variant.compare_at_price || 0);
          var am    = pr * q;
          var saved = (mrp > pr) ? (mrp - pr) * q : 0;
          tot += am;
          totalSaved += saved;
          var variantTitle = (variant.title && variant.title !== 'Default Title') ? ' - ' + variant.title : '';
          sel.push({
            label:  p.title + variantTitle,
            sku:    variant.sku || '-',
            qty:    q,
            mrp:    mrp,
            price:  pr,
            amount: am,
            saved:  saved
          });
        }
      });
    });

    if (sel.length === 0) {
      alert('Please add at least one product before downloading.');
      return;
    }

    var nd = new Date();
    var ds = nd.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

   var rf =
  'WEGS' +
  (1000000 + Date.now());

document.querySelectorAll('.wegs-ref').forEach(function(el) {
  el.textContent = rf;
});




    function fINR(n) {
      return 'Rs.' + Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2 });
    }

    var rows = '';
    sel.forEach(function(it, i) {
      rows += '<tr>'
        + '<td style="padding:8px 10px;">' + (i + 1) + '</td>'
        + '<td style="padding:8px 10px;">' + it.label + '</td>'
        + '<td style="padding:8px 10px;color:#888;">' + it.sku + '</td>'
        + '<td style="padding:8px 10px;text-align:right;text-decoration:line-through;color:#aaa;">' + (it.mrp > 0 ? fINR(it.mrp) : '-') + '</td>'
        + '<td style="padding:8px 10px;text-align:right;">' + fINR(it.price) + '</td>'
        + '<td style="padding:8px 10px;text-align:right;">' + it.qty + '</td>'
        + '<td style="padding:8px 10px;text-align:right;font-weight:700;">' + fINR(it.amount) + '</td>'
        + '<td style="padding:8px 10px;text-align:right;color:#2e7d32;font-weight:600;">' + (it.saved > 0 ? fINR(it.saved) : '-') + '</td>'
        + '</tr>';
    });

    var customerBlock = '<table style="width:100%;margin-bottom:24px;font-size:13px;">'
      + '<tr><td style="padding:4px 0;color:#888;width:140px;">Name</td><td style="padding:4px 0;font-weight:600;">' + name + '</td>'
      + '<td style="padding:4px 0;color:#888;width:140px;">Phone</td><td style="padding:4px 0;font-weight:600;">' + phone + '</td></tr>'
      + '<tr><td style="padding:4px 0;color:#888;">City</td><td style="padding:4px 0;">' + (city || '-') + '</td>'
      + '<td style="padding:4px 0;color:#888;">Email</td><td style="padding:4px 0;">' + (email || '-') + '</td></tr>'
      + '<tr><td style="padding:4px 0;color:#888;">Requirement</td><td colspan="3" style="padding:4px 0;font-weight:600;color:#D32F2F;">' + when + '</td></tr>'
      + '</table>';

    var hw = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>WEGS Estimate ' + rf + '</title>'
      + '<style>'
      + 'body{font-family:Arial,sans-serif;padding:40px;color:#1a1a1a;}'
      + '.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #D32F2F;padding-bottom:20px;margin-bottom:24px;}'
      + '.brand{font-size:36px;font-weight:900;color:#D32F2F;letter-spacing:3px;}'
      + '.sub{font-size:11px;color:#888;margin-top:2px;}'
      + '.dtitle{font-size:22px;font-weight:700;color:#D32F2F;}'
      + '.dref{font-size:13px;color:#555;margin-top:4px;}'
      + '.section-title{font-size:13px;font-weight:700;color:#D32F2F;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;border-bottom:1px solid #eee;padding-bottom:4px;}'
      + 'table.products{width:100%;border-collapse:collapse;}'
      + 'table.products thead tr{background:#D32F2F;color:#fff;}'
      + 'table.products thead th{padding:10px;text-align:left;font-size:12px;}'
      + 'table.products tbody tr:nth-child(even){background:#f9f9f9;} table.products tbody td{border:1px solid #e0e0e0;} table.products thead th{border:1px solid #c0392b;}'
      + '.tot td{font-weight:700;color:#D32F2F;border-top:2px solid #D32F2F;padding:12px 10px;font-size:14px;}'
      + '.saved-total td{font-weight:700;color:#2e7d32;padding:6px 10px;font-size:13px;}'
      + '.foot{margin-top:32px;font-size:11px;color:#aaa;border-top:1px solid #eee;padding-top:12px;text-align:center;}'
      + '</style></head><body>'
      + '<div class="hdr">'
      + '<div><div class="brand">WEGS</div><div class="sub">PRIVATE LIMITED &nbsp;|&nbsp; wegs.in</div></div>'
      + '<div style="text-align:right;"><div class="dtitle">ESTIMATE</div><div class="dref">Ref: ' + rf + '</div><div class="dref">Date: ' + ds + '</div><div class="dref">Valid Until: Price Change</div></div>'
      + '</div>'
      + '<div class="section-title">Customer Details</div>'
      + customerBlock
      + '<div class="section-title">Products</div>'
      + '<table class="products"><thead><tr>'
      + '<th>#</th><th>Product</th><th>SKU</th>'
      + '<th style="text-align:right;">MRP</th>'
      + '<th style="text-align:right;">Our Price</th>'
      + '<th style="text-align:right;">Qty</th>'
      + '<th style="text-align:right;">Amount</th>'
      + '<th style="text-align:right;">You Save</th>'
      + '</tr></thead><tbody>'
      + rows
      + '<tr class="tot"><td colspan="6" style="font-size:16px;">Total Payable - Including GST</td><td style="text-align:right;font-size:16px;">' + fINR(tot) + '</td><td></td></tr>'
      + (totalSaved > 0 ? '<tr class="saved-total"><td colspan="6" style="font-size:15px;">Total Savings</td><td></td><td style="text-align:right;font-size:15px;">' + fINR(totalSaved) + '</td></tr>' : '')
      + '</tbody></table>'
      + '<div class="foot">System-generated estimate from WEGS Private Limited (wegs.in). Valid until next price change.</div>'
      + '</body></html>';

                      return {
      html: hw,
      estimateId: rf,
      total: tot,

      items: sel.map(function(item) {
        return {
          productName: item.label,
          sku: item.sku || '',
          quantity: item.qty,
        };
      }),
    };
    
  }

});
